import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';

export const useTestCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      const res = await request.post('/test', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['test-list'] });
    }
  });
};

export const useTestUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const res = await request.patch(`/test/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['test-list'] });
      queryClient.invalidateQueries({ queryKey: ['test-get'] });
    }
  });
};

export const useTestDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/test/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['test-list'] });
    }
  });
};

export const useTestAddQuestions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ testId, data }: { testId: string; data: any }) => {
      const res = await request.post(`/test/${testId}/questions`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['test-questions-list'] });
    }
  });
};

export const useTestQuestionUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ questionId, data }: { questionId: string; data: any }) => {
      const res = await request.patch(`/test/question/${questionId}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['test-questions-list'] });
    }
  });
};

export const useTestQuestionDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (questionId: string) => {
      const res = await request.delete(`/test/question/${questionId}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['test-questions-list'] });
    }
  });
};
